const ProductVersionInitialValues = (showData) => ({
  version_ids: showData?.data?.versions?.map((version) => version.id) || [],
});

export default ProductVersionInitialValues;
